// extracted by mini-css-extract-plugin
export default {"tag":"tag_qE9H","tagRegular":"tagRegular_aHXt","tagWithCount":"tagWithCount_UC8q"};